module.exports = __webpack_public_path__ + "img/icon_close.2fccd85a.svg";